// PlanetConstants.js
import React, { useState } from 'react';
import './PlanetConstants.css';
// import planetMissions from './PlanetaryMissions';

export const PLANET_DATA = {
  Mercury: {
    id: 1,
    color: '#6D6D6D',
    description: "A small, rocky planet closest to the Sun, known for its extreme temperature swings and cratered surface.",
    mass: 3.3011e23,
    temperature: 440,
    soundUrl: "/soundtracks/MercurySoundtrack.mp3",
    satellites: 0,
    siderealPeriod: 87.97,
    perihelionJD: 2460876.5,
    J2000PrimeMeridianOffset: 281.01, 
    rings: false,
    missions: true,
    planetGlow: 'rgba(109, 109, 109, 0.8)',
  },
  Venus: {
    id: 2,
    color: '#FF9E00',
    description: "A hot, rocky world with a thick, toxic atmosphere and surface temperatures hot enough to melt lead.",
    mass: 4.8675e24,
    temperature: 737,
    soundUrl: "/soundtracks/VenusSoundtrack.mp3",
    satellites: 0,
    siderealPeriod: 224.70,
    perihelionJD: 2460780.5,
    J2000PrimeMeridianOffset: 160.20, 
    rings: false,
    missions: true,
    planetGlow: 'rgba(255, 158, 0, 0.8)',
  },
  Earth: {
    id: 3,
    color: '#4C97FF',
    description: "This is where we live; Earth is the third planet from the Sun and the only one known to support life.",
    mass: 5.97237e24,
    temperature: 288,
    soundUrl: "/soundtracks/EarthSoundtrack.mp3", 
    siderealPeriod: 365.25,
    perihelionJD: 2460685.5,
    J2000PrimeMeridianOffset: -79.53938163, 
    rings: false,
    missions: false,
    trackSatellites: true,
    planetGlow: 'rgba(76, 151, 255, 0.8)',
  },
  Moon: {
    id: 301,
    color: '#dfdfdf',
    description: "Earth's only natural satellite, the Moon influences Earth's tides and is 384,400 km away from us!",
    mass: 7.342e22,
    temperature: 220, // Average surface temperature in Kelvin
    soundUrl: "/soundtracks/MoonSoundtrack.mp3",
    satellites: 0,
    siderealPeriod: 27.3217,
    perihelionJD: 2460585.5,
    axialTilt: 1.54, // degrees relative to its orbital plane
    J2000PrimeMeridianOffset: 38.3213, // degrees
    rings: false,
    missions: true,
    planetGlow: "rgba(192, 192, 192, 0.5)",
  },
  Mars: {
    id: 4,
    color: '#D14E43',
    description: "The red, dusty planet with the largest volcano and canyon in the solar system, and signs it once had liquid water.",
    mass: 6.4171e23,
    temperature: 210,
    soundUrl: "/soundtracks/MarsSoundtrack.mp3",
    satellites: 2,
    siderealPeriod: 686.98,
    perihelionJD: 2460587.5,
    J2000PrimeMeridianOffset: 176.630, 
    rings: false,
    missions: true,
    marsExploration: true,
    planetGlow: 'rgba(209, 78, 67, 0.8)',
  },
  Jupiter: {
    id: 5,
    color: '#D18F4B',
    description: "Jupiter is the largest planet and has a Great Red Spot; famous for its massive storms and dozens of moon",
    mass: 1.8982e27,
    temperature: 165,
    soundUrl: "/soundtracks/JupiterSoundtrack.mp3",
    satellites: 95,
    siderealPeriod: 4332.59,
    perihelionJD: 2459651.5,
    J2000PrimeMeridianOffset: 67.1,
    rings: true,
    missions: true,
    planetGlow:  'rgba(209, 143, 75, 0.8)',
    ringDetails: {
      InnerRings:
                <> 
                <div style={{paddingBottom: '0.5rem'}}>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>Halo Ring: </strong> 
                    Jupiter’s faint, broad, and diffuse inner ring made mostly of fine dust particles.
                  </div>
                </div>
                <hr style={{ border: 'none', height: '2px', backgroundColor: 'black', width: '100%' }} />
                </>,                
      MainRings:
                <>
                <div style={{padding: '0.5rem 0rem 0.5rem 0rem'}}>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>Main Ring: </strong> 
                     Jupiter’s bright, thin ring composed of small rocky and icy particles orbiting close to the planet.
                  </div>              
                </div>
                <hr style={{ border: 'none', height: '2px', backgroundColor: 'black', width: '100%' }} />
                </>,
      OuterDiffuse:
                  <div>
                    <div style={{paddingTop: '0.5rem'}}>
                      <strong>Gossamer Ring: </strong> 
                      Jupiter’s faint, wide, and dusty ring formed from particles ejected by its small moons.
                    </div>                  
                  </div>,
    }
  },
  Saturn: {
    id: 6,
    color: '#F1D24A',
    description: "A gas giant renowned for its spectacular, icy ring system and many moons",
    mass: 5.6834e26,
    temperature: 134,
    soundUrl: "/soundtracks/SaturnSoundtrack.mp3",
    satellites: 146,
    siderealPeriod: 10759.22,
    perihelionJD: 2456950.5,
    J2000PrimeMeridianOffset: 38.9,
    rings: true,
    missions: true,
    planetGlow: 'rgba(241, 210, 74, 0.8)',
    ringDetails: {
      InnerRings:
                <> 
                <div style={{paddingBottom: '0.5rem'}}>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>D & C RINGS: </strong> 
                    Saturn’s faint and dusty inner rings, with D closest to the planet and C featuring magnetic spokes.
                  </div>                  
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>B RING: </strong> 
                    Saturn’s largest and brightest ring, dense icy chunks, shaped by moons and resonances.
                  </div>
                </div>
                <hr style={{ border: 'none', height: '2px', backgroundColor: 'black', width: '100%' }} />
                </>,                
      MainRings:
                <>
                <div style={{padding: '0.5rem 0rem 0.5rem 0rem'}}>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>CASSINI DIVISION: </strong> 
                    A wide, dark gap between the A and B rings, about 4,800 kilometers across.
                  </div>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>A RING: </strong> 
                    The outermost of Saturn’s large, bright rings, featuring the prominent Encke and Keeler gaps.
                  </div>
                </div>
                <hr style={{ border: 'none', height: '2px', backgroundColor: 'black', width: '100%' }} />
                </>,
      OuterDiffuse:
                  <div style={{paddingTop: '0.5rem'}}>
                    <div style={{paddingBottom: '0.5rem'}}>
                      <strong>F & G RINGS: </strong> 
                      Faint outer rings, with F being narrow and twisted, and G thin and icy.
                    </div>                    
                    <div>
                      <strong>E RING: </strong> 
                      Saturn’s widest and most diffuse ring, continuously fed by geysers from the moon Enceladus.
                    </div>
                  </div>,
    }
    
  },
  Uranus: {
    id: 7,
    color: '#1D9A9A',
    description: " An ice giant with a striking blue-green color, rotating on its side with a faint ring system.",
    mass: 8.6810e25,
    temperature: 76,
    soundUrl: "/soundtracks/UranusSoundtrack.mp3",
    satellites: 28,
    siderealPeriod: 30685.4,
    perihelionJD: 2446455.0,
    J2000PrimeMeridianOffset: 257.311, 
    rings: true,
    missions: true,
    planetGlow: 'rgba(29, 154, 154, 0.8)',
    ringDetails: {
      InnerRings:
                <> 
                <div style={{paddingBottom: '0.5rem'}}>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>ZETA RING: </strong> 
                    Uranus’s faint, innermost ring made of diffuse fine dust visible in scattered light.
                  </div>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>RINGS 6, 5, 4: </strong> 
                    Uranus’s narrow, dense inner rings of dark, dust-free particles with slight differences in shape.
                  </div>                  
                </div>
                <hr style={{ border: 'none', height: '2px', backgroundColor: 'black', width: '100%' }} />
                </>,                
      MainRings:
                <>
                <div style={{padding: '0.5rem 0rem 0.5rem 0rem'}}>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>ETA, ALPHA, BETA, GAMMA, DELTA RING: </strong> 
                    Narrow, dark rings farther from Uranus, made mostly of rocky particles.
                  </div>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>EPSILON RING: </strong> 
                    The brightest and widest of Uranus’s rings, composed of large, dark particles.
                  </div>
                </div>
                <hr style={{ border: 'none', height: '2px', backgroundColor: 'black', width: '100%' }} />
                </>,
      OuterDiffuse:
                  <div style={{paddingTop: '0.5rem'}}>
                    <div >
                      <strong>MU & NU RING: </strong> 
                      Faint, dusty outer rings of Uranus, with Nu known for its reddish tint and marking the edge of the ring system.
                    </div>                       
                  </div>,
    }
  },
  Neptune: {
    id: 8,
    color: '#1D3B7B',
    description: "The distant, deep blue ice giant with strong winds and a dynamic weather system.",
    mass: 1.02413e26,
    temperature: 72,
    soundUrl: "/soundtracks/NeptuneSoundtrack.mp3",
    satellites: 16,
    siderealPeriod: 60189.0,
    perihelionJD: 2444240.0,
    J2000PrimeMeridianOffset: 299.36,
    rings: true,
    missions: true,
    planetGlow: 'rgba(29, 59, 123, 0.8)',
    ringDetails: {
      InnerRings:
                <> 
                <div style={{paddingBottom: '0.5rem'}}>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>Adams Ring: </strong> 
                    Neptune’s faint, narrow innermost ring made of fine dust and ice.
                  </div>
                  
                </div>
                <hr style={{ border: 'none', height: '2px', backgroundColor: 'black', width: '100%' }} />
                </>,                
      MainRings:
                <>
                <div style={{padding: '0.5rem 0rem 0.5rem 0rem'}}>
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>Le Verrier Ring: </strong> 
                    A narrow, faint ring located just inside Neptune’s Adams ring, made of small icy particles.
                  </div> 
                  <div style={{paddingBottom: '0.5rem'}}>
                    <strong>Galle Ring: </strong> 
                    One of Neptune’s faint, dusty rings situated closer to the planet than the Le Verrier ring.
                  </div>              
                </div>
                <hr style={{ border: 'none', height: '2px', backgroundColor: 'black', width: '100%' }} />
                </>,
      OuterDiffuse:
                  <div style={{paddingTop: '0.5rem'}}>
                    <div>
                      <strong>Arago Ring: </strong> 
                      Neptune’s outermost narrow ring, almost invisible; famous for its bright arcs made of icy particles.
                    </div>                
                  </div>,
    }
  },
  Sun: {
    id: 10,
    color: '#FFD700',
    description: "The Sun is the center of our solar system, a giant ball of gas providing light and energy.",
    mass: 1.9885e30,
    temperature: 5778,
    soundUrl: "/soundtracks/SunSoundtrack.mp3",
    orbitalPeriod: "0 Earth days (0 Earth years)",
    J2000PrimeMeridianOffset: 0, 
    rings: false,
    planetGlow: 'rgba(255, 215, 0, 0.8)',
  },
  Pluto: {
    id: 999,
    color: '#b9a78f',
    description: "A dwarf planet in the Kuiper Belt, Pluto was once considered the ninth planet of our solar system but was reclassified as a dwarf planet in 2006. It has a highly elliptical and tilted orbit and is the largest known object in the Kuiper Belt by volume.",
    mass: 1.309e22,
    temperature: 44, // Average surface temperature in Kelvin
    soundUrl: "/soundtracks/PlutoSoundtrack.mp3",
    satellites: 5,
    siderealPeriod: 90560, // days (~248 Earth years)
    perihelionJD: 2451545.0, // Approximate J2000 epoch reference
    J2000PrimeMeridianOffset: 302.695, // degrees
    rings: false,
    missions: true,
    planetGlow: 'rgba(184, 164, 138, 0.5)',
  },

  // KUIPER BELT
  Eris: {
    id: 136199,
    color: '#d9d9d9',
    description: "The most massive known dwarf planet in the scattered disc beyond the Kuiper Belt. Eris was discovered in 2005 and its discovery prompted the IAU to redefine the term 'planet' in 2006.",
    mass: 1.6466e22,
    temperature: 30,
    // soundUrl: "/soundtracks/ErisSoundtrack.mp3",
    satellites: 1,
    siderealPeriod: 203830, // ~558 years
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(220,220,220,0.5)',
  },

  Haumea: {
    id: 136108,
    color: '#cfcfcf',
    description: "A rapidly rotating dwarf planet with an elongated shape and a ring system. Haumea is one of the largest known trans-Neptunian objects.",
    mass: 4.006e21,
    temperature: 43,
    // soundUrl: "/soundtracks/HaumeaSoundtrack.mp3",
    satellites: 2,
    siderealPeriod: 103774,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    // rings: true,
    rings: false,
    missions: false,
    planetGlow: 'rgba(200,200,200,0.5)',
  },

  Makemake: {
    id: 136472,
    color: '#d2b48c',
    description: "A reddish dwarf planet in the Kuiper Belt and one of the brightest known trans-Neptunian objects.",
    mass: 3.1e21,
    temperature: 40,
    // soundUrl: "/soundtracks/MakemakeSoundtrack.mp3",
    satellites: 1,
    siderealPeriod: 112897,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(210,180,140,0.5)',
  },

  Quaoar: {
    id: 50000,
    color: '#8b6f47',
    description: "A large classical Kuiper Belt object notable for its unexpected dense ring system.",
    mass: 1.4e21,
    temperature: 44,
    // soundUrl: "/soundtracks/QuaoarSoundtrack.mp3",
    satellites: 1,
    siderealPeriod: 104166,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    // rings: true,
    rings: false,
    missions: false,
    planetGlow: 'rgba(139,111,71,0.5)',
  },

  Sedna: {
    id: 90377,
    color: '#8a4b3d',
    description: "An extremely distant trans-Neptunian object with one of the longest known orbital periods in the Solar System.",
    mass: 1.0e21,
    temperature: 12,
    // soundUrl: "/soundtracks/SednaSoundtrack.mp3",
    satellites: 0,
    siderealPeriod: 4160000,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(138,75,61,0.5)',
  },

  Orcus: {
    id: 90482,
    color: '#a7a7a7',
    description: "A large plutino often considered Pluto's twin because of its similar size and orbital resonance with Neptune.",
    mass: 6.32e20,
    temperature: 44,
    // soundUrl: "/soundtracks/OrcusSoundtrack.mp3",
    satellites: 1,
    siderealPeriod: 90460,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(170,170,170,0.5)',
  },

  Ixion: {
    id: 28978,
    color: '#7c756d',
    description: "A plutino discovered in 2001 that follows a 2:3 orbital resonance with Neptune.",
    mass: 3e20,
    temperature: 44,
    // soundUrl: "/soundtracks/IxionSoundtrack.mp3",
    satellites: 0,
    siderealPeriod: 90400,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(124,117,109,0.5)',
  },

  "2002 TX300": {
    id: 55636,
    color: '#f5f5f5',
    description: "A bright classical Kuiper Belt object with one of the highest known albedos among trans-Neptunian objects.",
    mass: 1.5e20,
    temperature: 43,
    // soundUrl: "/soundtracks/2002TX300Soundtrack.mp3",
    satellites: 0,
    siderealPeriod: 104000,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(245,245,245,0.5)',
  },

  Salacia: {
    id: 120347,
    color: '#6d7c8a',
    description: "A large classical Kuiper Belt object with a single known moon, Actaea.",
    mass: 4.9e20,
    temperature: 44,
    // soundUrl: "/soundtracks/SalaciaSoundtrack.mp3",
    satellites: 1,
    siderealPeriod: 101600,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(109,124,138,0.5)',
  },

  Gonggong: {
    id: 225088,
    color: '#b45a5a',
    description: "A reddish dwarf planet candidate in the scattered disc with one known moon, Xiangliu.",
    mass: 1.75e21,
    temperature: 33,
    // soundUrl: "/soundtracks/GonggongSoundtrack.mp3",
    satellites: 1,
    siderealPeriod: 202500,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(180,90,90,0.5)',
  },

  "2002 MS4": {
    id: 307261,
    color: '#8d8d8d',
    description: "One of the largest known Kuiper Belt objects that has not yet been classified as a dwarf planet.",
    mass: 1.5e21,
    temperature: 43,
    // soundUrl: "/soundtracks/2002MS4Soundtrack.mp3",
    satellites: 0,
    siderealPeriod: 100000,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(141,141,141,0.5)',
  },

  Lempo: {
    id: 47171,
    color: '#a08d74',
    description: "A unique triple-object system located in the Kuiper Belt.",
    mass: 6e18,
    temperature: 44,
    // soundUrl: "/soundtracks/LempoSoundtrack.mp3",
    satellites: 2,
    siderealPeriod: 90500,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(160,141,116,0.5)',
  },

  Varda: {
    id: 174567,
    color: '#7b7b9d',
    description: "A large trans-Neptunian object in the classical Kuiper Belt with one known moon, Ilmarë.",
    mass: 2.45e20,
    temperature: 43,
    // soundUrl: "/soundtracks/VardaSoundtrack.mp3",
    satellites: 1,
    siderealPeriod: 113000,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(123,123,157,0.5)',
  },

  Varuna: {
    id: 20000,
    color: '#7c5b47',
    description: "One of the earliest large Kuiper Belt objects discovered, notable for its rapid rotation and elongated shape.",
    mass: 3.7e20,
    temperature: 43,
    // soundUrl: "/soundtracks/VarunaSoundtrack.mp3",
    satellites: 0,
    siderealPeriod: 102100,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(124,91,71,0.5)',
  },

  Chaos: {
    id: 19521,
    color: '#888888',
    description: "A classical Kuiper Belt object discovered in 1998 and named after the primordial Greek deity Chaos.",
    mass: 1e20,
    temperature: 43,
    // soundUrl: "/soundtracks/ChaosSoundtrack.mp3",
    satellites: 0,
    siderealPeriod: 112000,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(136,136,136,0.5)',
  },

  "2002 AW197": {
    id: 55565,
    color: '#9b8d7c',
    description: "A large classical Kuiper Belt object considered a likely dwarf planet candidate.",
    mass: 3e20,
    temperature: 43,
    // soundUrl: "/soundtracks/2002AW197Soundtrack.mp3",
    satellites: 0,
    siderealPeriod: 114000,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(155,141,124,0.5)',
  },

  "2002 UX25": {
    id: 55637,
    color: '#7d6b62',
    description: "A dwarf planet candidate in the Kuiper Belt with a known satellite named Weywot.",
    mass: 1.25e20,
    temperature: 43,
    // soundUrl: "/soundtracks/2002UX25Soundtrack.mp3",
    satellites: 1,
    siderealPeriod: 101700,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(125,107,98,0.5)',
  },

  "2002 TC302": {
    id: 84522,
    color: '#9c9c9c',
    description: "A large scattered disc object and strong dwarf planet candidate beyond Neptune.",
    mass: 1.8e20,
    temperature: 40,
    // soundUrl: "/soundtracks/2002TC302Soundtrack.mp3",
    satellites: 0,
    siderealPeriod: 201000,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(156,156,156,0.5)',
  },

  "2003 AZ84": {
    id: 208996,
    color: '#7f7f7f',
    description: "A plutino and likely dwarf planet candidate that shares Neptune's 2:3 orbital resonance.",
    mass: 2.3e20,
    temperature: 43,
    // soundUrl: "/soundtracks/2003AZ84Soundtrack.mp3",
    satellites: 1,
    siderealPeriod: 90450,
    perihelionJD: 2451545.0,
    J2000PrimeMeridianOffset: 0,
    rings: false,
    missions: false,
    planetGlow: 'rgba(127,127,127,0.5)',
  },
};

const superscriptDigits = {
  '0': '⁰',
  '1': '¹',
  '2': '²',
  '3': '³',
  '4': '⁴',
  '5': '⁵',
  '6': '⁶',
  '7': '⁷',
  '8': '⁸',
  '9': '⁹',
  '-': '⁻',
};

function toSuperscript(str) {
  return str
    .split('')
    .map(char => superscriptDigits[char] || char)
    .join('');
}

export function formatScientificNotationSup(value) {
  if (value === 0) return '0';

  const match = value.toExponential().match(/^([\d.]+)e([+-]?\d+)$/);
  if (!match) return value.toString();

  const base = parseFloat(match[1]).toFixed(2);
  let exponent = match[2];
  if (exponent.startsWith('+')) exponent = exponent.slice(1);

  return `${base} × 10${toSuperscript(exponent)}`;
}

export function TemperatureToggle({ kelvin, onGlow }) {
  const [isCelsius, setIsCelsius] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const formatTemperature = (k) => {
    if (typeof k !== 'number') return 'N/A';
    return isCelsius
      ? `${(k - 273.15).toFixed(1)} °C`
      : `${k.toFixed(1)} K`;
  };

  const handleClick = () => {
    if (isAnimating) return; // prevent clicks during animation

    if (onGlow) {
      onGlow(kelvin);
      setIsAnimating(true);
      // Assuming your animation lasts 2 seconds (adjust as needed)
      setTimeout(() => {
        setIsAnimating(false);
      }, 2100);
    } else {
      console.warn("No onGlow prop passed!");
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '0.5rem 0',
      }}
    >
      <div
        style={{
          position: 'relative',
          flex: 1,
          marginRight: '1rem',
          minHeight: '3rem',
        }}
      >
        <strong>Temperature:</strong> {formatTemperature(kelvin)}
        <div style={{ fontSize: '0.85em', color: '#ccc' }} className="pulse-text">(Experience it!)</div>
        <button
          onClick={handleClick}
          disabled={isAnimating}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'transparent',
            border: 'none',
            zIndex: 999999,
          }}
          aria-label="Trigger temperature glow effect"
        />
      </div>
      <div
        style={{
          display: 'flex',
          border: '1px solid #666',
          borderRadius: '4px',
          overflow: 'hidden',
        }}
      >
        <button
          onClick={() => setIsCelsius(false)}
          style={{
            padding: '4px 8px',
            background: !isCelsius ? '#fff' : '#444',
            color: !isCelsius ? '#000' : '#ccc',
            border: 'none',
            cursor: 'pointer',
            fontWeight: !isCelsius ? 'bold' : 'normal',
          }}
        >
          K
        </button>
        <button
          onClick={() => setIsCelsius(true)}
          style={{
            padding: '4px 8px',
            background: isCelsius ? '#fff' : '#444',
            color: isCelsius ? '#000' : '#ccc',
            border: 'none',
            cursor: 'pointer',
            fontWeight: isCelsius ? 'bold' : 'normal',
          }}
        >
          °C
        </button>
      </div>
    </div>
  );
}

export function RingDetails({PlanetRings, isMobile}){

  return(
    <div style={{ fontSize: isMobile ? '0.72rem' : '0.63rem', paddingTop: '0.5rem' }}>
    {/* // <div style={{ fontSize: isMobile ? '0.63rem' : '0.5rem', paddingTop: '0.5rem' }}>  */}
      {PlanetRings.InnerRings}
      {PlanetRings.MainRings}
      {PlanetRings.OuterDiffuse}
    </div>
    
  );

}